
(function($){
    // JS
    window.Share = {

        // Get the share price from the api endpoint
        //======================================================================
        getSharePrice: function()
        {
            var data = $('.js-data');
            var change = $('.js-change');
            var updated = $('.js-updated');

            $.ajax({
                method: 'post',
                data: {
                    'action': 'get_modfin_data',
                    'widget': 'stock_table'
                },
                url: "/wp-admin/admin-ajax.php",
                dataType: 'json',
                success: function (result) {
                  var name = result.stocks[0].stockSymbol;
                  var ask = Number(result.stocks[0].latestPrice).toFixed(2);
                  var currency = "SEK";
                    var percentageChange = (result.stocks[ 0 ].deltaToday * 100).toFixed(2);
                    if (percentageChange > 0)
                        percentageChange = "+" + percentageChange
                  var timezone = "CET";
                  var time = result.stocks[0].latestTime;
                  var date = result.stocks[0].latestDate;

                  dateString = new Date(date);

                  data.html('<span>' + name + ' </span>' + ask + ' ' + currency);
                  change.html(percentageChange+'%');
                  updated.html(time + ' ' + timezone + ' ' + dateString.toDateString());
                },
                error: function (result) {
                  console.log("error res", result)
                  console.warn(result);
                }
            });
        }
    }
    // Run
    $(function(){
        Share.getSharePrice();
    });


}(jQuery));